import React, { useEffect, useState } from "react";
import "./Countdown.scss";
import Clock_0 from "../img/clock/0.png";
import Clock_1 from "../img/clock/1.png";
import Clock_2 from "../img/clock/2.png";
import Clock_3 from "../img/clock/3.png";
import Clock_4 from "../img/clock/4.png";
import Clock_5 from "../img/clock/5.png";
import Clock_6 from "../img/clock/6.png";
import Clock_7 from "../img/clock/7.png";
import Clock_8 from "../img/clock/8.png";
import Clock_9 from "../img/clock/9.png";

interface TimeLeft {
    days: number;
    hours: number;
    minutes: number;
}

const calculateTimeLeft = (target: string) => {
  const difference = +new Date(target) - +new Date();
  let timeLeft: TimeLeft = {
      days: 0,
      hours: 0,
      minutes: 0
  };

  if (difference > 0) {
    timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
    };
  }

  return timeLeft;
};

function pad(value: number | string, length: number): string {
    return (value.toString().length < length) ? pad("0" + value.toString(), length): value.toString();
}

interface IAppProps {
    targetDate: string;
}



export const ClockPart: React.FunctionComponent<{ part: number }> = (props) => {
    const partForString = (p: string) => {
        switch(p) {
            case "0":
                return Clock_0;
            case "1":
                return Clock_1;
            case "2":
                return Clock_2;
            case "3":
                return Clock_3;
            case "4":
                return Clock_4;
            case "5":
                return Clock_5;
            case "6":
                return Clock_6;
            case "7":
                return Clock_7;
            case "8":
                return Clock_8;
            case "9":
                return Clock_9;
        }
    }
    const parts = pad(props.part, 2).split("");
    let part1 = partForString(parts[0]);
    let part2 = partForString(parts[1]);

    return (<div>
        <img src={part1} alt=""/>
        <img src={part2} alt=""/>
    </div>)
};

export const Countdown: React.FunctionComponent<IAppProps> = (props) => {
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(props.targetDate));

    useEffect(() => {
        const timer = setTimeout(() => {
          setTimeLeft(calculateTimeLeft(props.targetDate));
        }, 1000);
        return () => clearTimeout(timer);
      });

    return (<div className="countdown">
        <div className="countdown-part">
            <ClockPart part={timeLeft.days} />
            <div className="time-label">Days</div>
        </div>
        <div className="countdown-part colon">
            <div></div>
            <div></div>
        </div>
        <div className="countdown-part">
            <ClockPart part={timeLeft.hours} />
            <div className="time-label">Hours</div>
        </div>
        <div className="countdown-part colon">
            <div></div>
            <div></div>
        </div>
        <div className="countdown-part">
            <ClockPart part={timeLeft.minutes} />
            <div className="time-label">Minutes</div>
        </div>
    </div>);
};
